import {all, fork ,call, put, takeEvery, takeLatest  } from 'redux-saga/effects'
import { push } from 'react-router-redux';
import NetworkHandler from '../net/NetworkHandler'
import StorageHandler from '../storage/StorageHandler';
import * as ACTIONS from '../containers/constants';
import { error ,success } from '../components/Alert/actions';
import {updateLinkedCryodex} from '../containers/LinkedCryodex/actions';
const storageHandler = new StorageHandler();

function* getLinkedCryodex(action){

  const Network = new NetworkHandler();
  
    try{

      const response = yield Network.requestGetUserProfileInfomation(action.payload);
      if (!(response instanceof Error)) {
          yield put(
            updateLinkedCryodex(
                response
              )
            );
        } else {
          yield put(
            error({
              message: `Unable to get linked cryodex. ${response}`,
            })
          );
        }
    }catch (errorMsg) {
        yield put(
            error({
             message: `Unable to load linked cryodex, please try again.${errorMsg}`,
            })
        );
    }
}

export default function* usersSagas() {
  yield takeLatest(ACTIONS.CRYODEX_CRYODEX_LINKED_GET, getLinkedCryodex);
}

